import { Hidden, Grid } from "@material-ui/core"
import Typography from "@material-ui/core/Typography"
import User, { Roles } from "app/models/user"
import { logout } from "app/redux/authentication/authentication.actions"
import { getCurrentUser } from "app/redux/currentUser/currentUser.selectors"
import IState from "app/redux/state"
import Translation from "components/Translation"
import AvatarIcon from "components/Icons/Avatar.icon"
import React, { Dispatch, memo } from "react"
import { connect } from "react-redux"
import { RouteComponentProps, withRouter } from "react-router"
import { Action } from "redux"
import { StyledUserContainerGrid, StyledAvatarButton, StyledLogoutButton } from "./style"
import { useAccessRoles } from "../AccessRoles"

type StateProps = {
  user: User | undefined
}

type DispatchProps = {
  logout: () => void
}

type Props = DispatchProps & StateProps & RouteComponentProps

function UserBar({ logout, user, history }: Props): JSX.Element {
  const { isAllowed: isAllowedToClick } = useAccessRoles([Roles.Planner, Roles.HROfficer, Roles.User])

  const handleLogout = (): void => {
    logout()
  }

  const onClickProfile = () => {
    isAllowedToClick && history.push(`/employees/${user && user.id}/employee-details`)
  }

  const fullName = (): string => (user && `${user && user.first_name} ${user && user.last_name}`) || ""

  return (
    <StyledUserContainerGrid container={true} justifyContent="flex-end" alignItems="center" spacing={2}>
      <Hidden mdDown={true}>
        <Grid item={true}>
          <Typography data-cy="userbar-userName-text" component="p" variant="h4" color="inherit" align="right">
            {fullName()}
          </Typography>
        </Grid>
      </Hidden>
      <Grid item={true}>
        <StyledAvatarButton
          data-cy="userbar-employeeDetail-action"
          onClick={onClickProfile}
          className="StyledIconButton"
        >
          <AvatarIcon />
        </StyledAvatarButton>
      </Grid>
      <Grid item={true}>
        <StyledLogoutButton color="primary" variant="text" onClick={handleLogout}>
          <Translation label="navigation.userprofile.button.logout" />
        </StyledLogoutButton>
      </Grid>
    </StyledUserContainerGrid>
  )
}

const mapStateToProps = (state: IState): StateProps => ({
  user: getCurrentUser(state),
})

const mapDispatchToProps = (dispatch: Dispatch<Action>): DispatchProps => ({
  logout: () => dispatch(logout()),
})
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(memo(UserBar)))
